<template>
  <van-button size="mini" :disabled="disabled || !!codeSeconds"
    type="info" @click="sendVerificationCode" native-type="button">
    {{ $t('发送验证码') }}
    {{ codeSeconds ? `(${codeSeconds}s)` : '' }}
  </van-button>
</template>

<script>
import { Button, Toast } from 'vant'
import { isPhone, isEmail } from '../utils/contact-type'
import ls from '../utils/local-storage'
import { LS_KEYS } from '../constants'

export default {
  name: 'verification-code',
  components: {
    'van-button': Button
  },
  props: {
    mode: String,
    type: { // 'login' | 'resetpwd'
      type: String,
      required: true
    },
    name: { // use as a key to save timestamp to local storage
      type: String,
      required: true
    },
    contact: {
      type: String,
      required: true
    },
    disabled: Boolean
  },
  data () {
    return {
      codeSeconds: 0
    }
  },
  computed: {
    localStorageKey () {
      return LS_KEYS.VERIFY_CODE_TIME_PREFIX + this.name
    },
    isContactPhone () {
      return isPhone(this.contact)
    },
    isContactEmail () {
      return isEmail(this.contact)
    }
  },
  methods: {
    sendVerificationCode () {
      let api = null

      if (this.mode) {
        if (this.mode === 'phone') {
          if (!this.isContactPhone) {
            Toast(this.$t('请输入正确的手机号码'))
            return
          }
          api = this.$apis.auth.sendValidatedCode
        }
        if (this.mode === 'email') {
          if (!this.isContactEmail) {
            Toast(this.$t('请输入正确的邮箱地址'))
            return
          }
          api = this.$apis.auth.sendEmailCode
        }
      } else {
        if (this.isContactPhone) {
          api = this.$apis.auth.sendValidatedCode
        }
        if (this.isContactEmail) {
          api = this.$apis.auth.sendEmailCode
        }
        if (!api) {
          Toast(this.$t('请输入正确的联系方式'))
          return
        }
      }

      ls.set(this.localStorageKey, new Date().getTime())
      this.startCodeTimer()
      api(
        this.contact,
        this.type,
        () => {
          this.clearCodeTimer()
          return true
        }
      )
        .catch(() => this.clearCodeTimer())
    },
    startCodeTimer () {
      const codeTime = ls.get(this.localStorageKey)
      if (codeTime) {
        this.codeSeconds = 60 - Math.floor((new Date().getTime() - codeTime) / 1000)
        if (this.codeSeconds > 0) {
          this.timer = window.setInterval(() => {
            const now = new Date().getTime()
            this.codeSeconds = 60 - Math.floor((now - codeTime) / 1000)
            if (this.codeSeconds <= 0) {
              this.clearCodeTimer()
            }
          }, 1000)
        } else {
          this.clearCodeTimer()
        }
      }
    },
    clearCodeTimer () {
      this.codeSeconds = 0
      ls.remove(this.localStorageKey)
      this.timer && window.clearInterval(this.timer)
    }
  },
  mounted () {
    this.startCodeTimer()
  },
  beforeDestroy () {
    if (this.timer) {
      window.clearInterval(this.timer)
    }
  }
}
</script>
